/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnrolmentsList } from '../../models/enrolments-list';

export interface ApiCourseCoursesCourseIdEnrolmentsGet$Params {
  course_id: number;
}

export function apiCourseCoursesCourseIdEnrolmentsGet(http: HttpClient, rootUrl: string, params: ApiCourseCoursesCourseIdEnrolmentsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<EnrolmentsList>> {
  const rb = new RequestBuilder(rootUrl, apiCourseCoursesCourseIdEnrolmentsGet.PATH, 'get');
  if (params) {
    rb.path('course_id', params.course_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EnrolmentsList>;
    })
  );
}

apiCourseCoursesCourseIdEnrolmentsGet.PATH = '/api/course/courses/{course_id}/enrolments';
